import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {ErrorHandlerComponent} from "./pages/error-handler/components/error-handler.component";
import {ReviewPageComponent} from "./pages/review-page/components/review-page.component";
import {CheckoutCartComponent} from "./pages/checkout-cart/components/checkout-cart.component";
import {devWebsite} from './shell/auth/developer-site-auth/dev-website.guard';
import {DeveloperAuthComponent} from './shell/auth/developer-site-auth/developer-auth/developer-auth.component';
import {env, environment} from "../environments/environment.prod";
const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./pages/home/module/home.module').then(m => m.HomeModule)
  },
  {
    path: 'ordering',
    loadChildren: () => import('./pages/ordering/module/ordering.module').then(m => m.OrderingModule)
  },
  {
    path: 'info',
    loadChildren: () => import('./pages/information/information-page.module').then(m => m.InformationPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/module/profile.module').then(m => m.ProfileModule)
  },
  {
    path: 'app-link',
    loadChildren: () => import('./link-page/link-page.module').then(m => m.LinkPageModule)
  },
  {
    path: 'p',
    loadChildren: () => import('./pages/activate-promocode/module/activate-promocode.module')
    .then((m) => m.ActivatePromocodeModule),
  },
  {path: '', redirectTo: 'home', pathMatch: 'full'},
  {path: 'reviews', component: ReviewPageComponent},
  {path: 'checkout-card', component: CheckoutCartComponent},
  {path: 'error', component: ErrorHandlerComponent},
  {
    path: '404',
    loadChildren: () => import('./pages/not-found/modules/not-found.module').then(m => m.NotFoundModule)
  },
  {
    path: '**',
    redirectTo: '404'
  },
];

const appliedRoutes = environment.url === env.developer ? [
  {path: 'login', component: DeveloperAuthComponent},
  {path: '', children: routes, canActivate: [devWebsite]},
  {path: '**', redirectTo: 'login'}] : routes;

@NgModule({
  imports: [RouterModule.forRoot(appliedRoutes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
